import type { Namespace } from './types';

export const zh: Namespace = {
  fxQuotes: {
    title: '汇率报价',
    usdRate: '美金汇率',
    searchPlaceholder: '搜索地区 / 货币',
    regionLabel: '地区',
    regionCount: '地区 {{selected}} / {{total}}',
    selectAll: '全选',
    clearAll: '取消',
    empty: '没有匹配的地区',
    meta: 'fx 快照 · {{time}}',
    fields: {
      region: '地区',
      ccy: '货币',
      rate: '货币汇率',
      quote: '汇率报价',
    },
    regions: {
      GBP: '英国',
      EUR: '欧元区',
      CHF: '瑞士',
      CAD: '加拿大',
      AUD: '澳大利亚',
      NZD: '新西兰',
      HKD: '中国香港',
      PLN: '波兰',
      BRL: '巴西',
      US: '美国',
      TR: '土耳其',
      AR: '阿根廷',
      CIS: '独联体',
      MENA: '中东北非',
      LATAM: '拉美',
      SASIA: '南亚',
      CNY: '中国大陆',
      TWD: '中国台湾',
      JPY: '日本',
      KRW: '韩国',
      SGD: '新加坡',
      MYR: '马来西亚',
      THB: '泰国',
      IDR: '印度尼西亚',
      VND: '越南',
      PHP: '菲律宾',
      INR: '印度',
      RUB: '俄罗斯',
      UAH: '乌克兰',
      KZT: '哈萨克斯坦',
      ILS: '以色列',
      SAR: '沙特阿拉伯',
      AED: '阿联酋',
      QAR: '卡塔尔',
      KWD: '科威特',
      ZAR: '南非',
      NOK: '挪威',
      MXN: '墨西哥',
      CLP: '智利',
      COP: '哥伦比亚',
      CRC: '哥斯达黎加',
      PEN: '秘鲁',
      UYU: '乌拉圭',
    },
  },
};

export const en: Namespace = {
  fxQuotes: {
    title: 'Fx Quotes',
    usdRate: 'USD rate',
    searchPlaceholder: 'Search region / currency',
    regionLabel: 'Regions',
    regionCount: 'Regions {{selected}} / {{total}}',
    selectAll: 'All',
    clearAll: 'None',
    empty: 'No matching regions',
    meta: 'fx snapshot · {{time}}',
    fields: {
      region: 'Region',
      ccy: 'Currency',
      rate: 'Fx rate',
      quote: 'Quote',
    },
    regions: {
      GBP: 'United Kingdom',
      EUR: 'Eurozone',
      CHF: 'Switzerland',
      CAD: 'Canada',
      AUD: 'Australia',
      NZD: 'New Zealand',
      HKD: 'Hong Kong SAR',
      PLN: 'Poland',
      BRL: 'Brazil',
      US: 'United States',
      TR: 'Turkey',
      AR: 'Argentina',
      CIS: 'CIS',
      MENA: 'MENA',
      LATAM: 'Latin America',
      SASIA: 'South Asia',
      CNY: 'Mainland China',
      TWD: 'Taiwan, China',
      JPY: 'Japan',
      KRW: 'South Korea',
      SGD: 'Singapore',
      MYR: 'Malaysia',
      THB: 'Thailand',
      IDR: 'Indonesia',
      VND: 'Vietnam',
      PHP: 'Philippines',
      INR: 'India',
      RUB: 'Russia',
      UAH: 'Ukraine',
      KZT: 'Kazakhstan',
      ILS: 'Israel',
      SAR: 'Saudi Arabia',
      AED: 'United Arab Emirates',
      QAR: 'Qatar',
      KWD: 'Kuwait',
      ZAR: 'South Africa',
      NOK: 'Norway',
      MXN: 'Mexico',
      CLP: 'Chile',
      COP: 'Colombia',
      CRC: 'Costa Rica',
      PEN: 'Peru',
      UYU: 'Uruguay',
    },
  },
};
